import script from "./FileAttachmentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FileAttachmentItem.vue?vue&type=script&setup=true&lang=js"

import "./FileAttachmentItem.vue?vue&type=style&index=0&id=6edfe1af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edfe1af"]])

export default __exports__